/**
 * What Apollo's `Autocomplete`-backed select (`ui/select`, creatable or not) draws as its
 * dropdown affordance: a plain chevron, not MUI's default filled-triangle `ArrowDropDownIcon`.
 *
 * Lives with the theme because it is `defaultProps`, reaching every `MuiAutocomplete` from one place.
 *
 * Unlike the checkbox/radio `icon` / `checkedIcon` slots, MUI renders `popupIcon` as-is — no
 * `cloneElement`, so this needs no prop-swallowing wrapper. It also already flips the icon 180deg on open
 * via its own `.MuiAutocomplete-popupIndicatorOpen` rule, and `assets/icons/chevron-down.svg` is a
 * symmetric glyph, so the rotated element *is* the open state — no second icon needed.
 */

import Icons from "assets";

export const AUTOCOMPLETE_POPUP_ICON = <Icons.ChevronDown aria-hidden />;
